// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
import 'leaflet/dist/leaflet.css';
import './styles.css';
import { mount } from './app';
import { initTooltip } from './tooltip';

initTooltip();
mount(document.getElementById('app')!);
